import { IFormBuilder } from '../IFormBuilder';
import { SearchPricingFormGroup } from '../SearchPricingFormGroup';
import { FormControl } from '@angular/forms';
import { AddressFormGroup } from '../AddressFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';

interface ISearchPricingFormBuilder extends IFormBuilder<SearchPricingControls> {
  init(): ISearchPricingFormBuilder;

  build(): SearchPricingFormGroup;
}

export type SearchPricingControls = {
  quantity: FormControl;
  pickupAddress: AddressFormGroup;
  deliveryAddress: AddressFormGroup;
};

export class SearchPricingFormBuilder implements ISearchPricingFormBuilder {
  private formName = 'searchPricingForm';
  private controls!: SearchPricingControls;

  constructor(private bcf: BaryFormFactoryService) {}

  init(): SearchPricingFormBuilder {
    this.controls = this.bcf.makeSearchPricingControls();
    return this;
  }

  build(): SearchPricingFormGroup {
    return new SearchPricingFormGroup(this.formName, this.controls);
  }
}
